import React, { useEffect, useRef, useState } from "react";
import axios from "axios";
import { Dialog, DialogContent, DialogTitle, DialogDescription } from "../ui/dialog";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const TicketPdfButton = ({ eventId, resourceId, label, filename = "ticket.pdf" }) => {
  const [pdf, setPdf] = useState(null);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");
  const mounted = useRef(true);
  const activeUrl = useRef(null);
  useEffect(() => {
    mounted.current = true;
    return () => {
      mounted.current = false;
      if (activeUrl.current) URL.revokeObjectURL(activeUrl.current);
    };
  }, []);
  const close = () => {
    if (activeUrl.current) URL.revokeObjectURL(activeUrl.current);
    activeUrl.current = null;
    setPdf(null);
  };
  const open = async () => {
    if (busy) return;
    setBusy(true); setError("");
    try {
      const response = await axios.get(
        `${API}/events/${encodeURIComponent(eventId)}/tickets/${encodeURIComponent(resourceId)}/pdf`,
        { responseType: "blob" }
      );
      if (!mounted.current) return;
      if (!(response.data instanceof Blob) || response.data.type !== "application/pdf") {
        throw new Error("PDF unavailable");
      }
      activeUrl.current = URL.createObjectURL(response.data);
      setPdf({ url: activeUrl.current });
    } catch {
      if (mounted.current) setError("We couldn’t open this ticket. The original email may be unavailable. Please try again.");
    } finally {
      if (mounted.current) setBusy(false);
    }
  };
  return <>
    <button type="button" onClick={open} disabled={busy}
      className="min-h-[44px] text-sm font-semibold text-[#4A5D4E] underline disabled:opacity-50">
      {busy ? "Opening ticket…" : `Open ticket PDF${label ? ` · ${label}` : ""}`}
    </button>
    {error && <p role="alert" className="text-sm text-red-700">{error}</p>}
    <Dialog open={!!pdf} onOpenChange={next => { if (!next) close(); }}>
      {pdf && <DialogContent className="flex h-[90dvh] max-w-[95vw] flex-col bg-white p-4 sm:rounded-xl">
      <DialogTitle>Ticket PDF</DialogTitle>
      <DialogDescription>Save a copy to use when you arrive.</DialogDescription>
      <div className="flex items-center justify-between gap-3 pb-3">
        <a href={pdf.url} download={filename} className="min-h-[44px] font-semibold underline">Save PDF</a>
        <button type="button" onClick={close} className="min-h-[44px] font-semibold">Close ticket</button>
      </div>
      <iframe src={pdf.url} title={label || "Ticket PDF"} className="w-full flex-1 border-0" />
      <p className="mt-2 text-sm">If the preview does not display, choose Save PDF.</p>
    </DialogContent>}
    </Dialog>
  </>;
};
